module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing fk__landing"
  }, [_c('div', {
    staticClass: "fk__landing__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__landing__container"
  }, [_c('h1', {
    staticClass: "fk__landing__heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('p', {
    staticClass: "fk__landing__copy"
  }, [_vm._v(_vm._s(_vm.copy))]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__landing__cta",
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v(_vm._s(_vm.cta))]), _vm._v(" "), _c('svg', {
    staticClass: "fk__landing__play",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.414"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(5.087 5.087)"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "a"
    }
  }, [_c('path', {
    attrs: {
      "d": "M44.956 89.913c24.83 0 44.957-20.128 44.957-44.957C89.913 20.128 69.785 0 44.956 0 20.128 0 0 20.128 0 44.956c0 24.83 20.128 44.957 44.956 44.957z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#a)"
    }
  }, [_c('path', {
    staticClass: "fk__landing__play--circle",
    attrs: {
      "fill": "#fff",
      "fill-rule": "nonzero",
      "d": "M-5-5h99.913v99.913H-5z"
    }
  })])]), _c('g', {
    attrs: {
      "transform": "translate(5.087 5.087)"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('path', {
    attrs: {
      "d": "M61.907 46.43L36.85 58.96V33.9L61.907 46.43z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#b)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#5B4B49",
      "fill-rule": "nonzero",
      "d": "M31.85 28.902h35.058V63.96H31.85z"
    }
  })])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f023e3d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Landing.vue
// module id = 78
// module chunks = 0